export default __webpack_public_path__ + "media/images/backgrounds/mud_splats/splat-3-233205dfcded5bf628551c9c03ba3684.svg";